import React from "react";
import { useTranslation } from "react-i18next";

const SessionExpiredModal = ({ isOpen, onConfirm }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-center items-center px-6 py-4 border-b border-gray-200 feedHeader">
          <h2 className="FeedHeaderPnc font-bold text-center">{t("sessionExpiredTitle")}</h2>
        </div>
        <div className="p-6 text-center contentModalPnc">
          <p className="subHeadingFeedPnc mb-6">{t("sessionExpiredBody")}</p>
          <button
            onClick={onConfirm}
            className="bg-[#FF0000] text-white px-8 py-3 rounded-full font-medium hover:bg-red-600 transition-colors focus:outline-none submitFeedPnc deleteBtnPnc"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
